import { useMediaQuery, useTheme } from '@mui/material';

/**
 * @returns {Boolean} indicates if user is currently on phone or PC/tablet
 */
export default () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return fullScreen;
};
